import React from 'react';
import { Link } from 'react-router-dom';
import { useVendor } from '../context/VendorContext';
import './TopBar.css';

const TopBar = ({ user, loading, onLogout, onShowAuthModal }) => {
  const { branding } = useVendor();

  return (
    <header className="v2-topbar">
      <div className="topbar-left">
        <Link to="/" className="topbar-brand">
          <img src={branding.logoUrl} alt={branding.appName} className="brand-logo" />
        </Link>
      </div>

      <div className="topbar-right">
        {user ? (
          <div className="topbar-user">
            <div className="topbar-avatar">
              {(user.first_name || user.email || 'U').charAt(0).toUpperCase()}
            </div>
            <button className="btn-logout" onClick={onLogout}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                <polyline points="16 17 21 12 16 7"/>
                <line x1="21" y1="12" x2="9" y2="12"/>
              </svg>
            </button>
          </div>
        ) : loading ? (
          <div className="topbar-auth-loading" />
        ) : (
          <div className="topbar-auth">
            <button className="btn-join" onClick={onShowAuthModal}>Join</button>
            <button className="btn-signup" onClick={onShowAuthModal}>Sign up</button>
          </div>
        )}
      </div>
    </header>
  );
};

export default TopBar;
